import cx from 'classnames';
import React, { FC, useCallback, useState } from 'react';
import { Button } from 'mui';
import { trackEvent } from 'app/utils/useCommonTracking';

const ReferralLink: FC<{
  referralCode: string;
}> = ({ referralCode }) => {
  const [isCopied, setIsCopied] = useState(false);
  const referralLink = `maximustribe.com/invite/${referralCode}`;

  const handleCopy = useCallback(() => {
    navigator.clipboard
      .writeText(referralLink)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      })
      .catch((err) => {
        console.error('Could not copy text: ', err);
      });

    trackEvent('Referral Link Copied');
  }, [referralLink]);

  return (
    <div>
      <p className="text-[12px] font-[400] text-[#182782] mt-6">Share your link</p>
      <div className="flex border border-[#798DFF] rounded-lg h-[56px] items-center justify-between overflow-hidden mb-4">
        <span className="text-[#2E4CFF] font-[500] text-[16px] p-3 flex-grow cursor-pointer" onClick={handleCopy}>
          {referralLink}
        </span>
        <span className={cx({ 'w-[68px]': isCopied, 'w-[60px]': !isCopied })}>
          <Button
            className={cx('h-[32px] mr-3 text-[#2E4CFF]')}
            variant="contained"
            onClick={handleCopy}
            disabled={isCopied}
            testid="copy-referral-link"
          >
            {isCopied ? 'Copied' : 'Copy'}
          </Button>
        </span>
      </div>
    </div>
  );
};

export default ReferralLink;
